import React, { ReactNode } from 'react';
import { I18n } from 'react-redux-i18n';
import { Slide, toast, ToastOptions } from 'react-toastify';
import { isMobile } from '../../services/deviceService';
import { toMessage } from '../../network/network';
import { WsError } from '../../network/WsTypes';
import notificationWarning from '../../img/notification/en_cours.svg';
import notificationSucces from '../../img/notification/succes.svg';
import notificationDelegate from '../../img/notification/droits_delegues.svg';
import notificationRattachement from '../../img/notification/demande_rattachement.svg';

export function option(autoclose = true): ToastOptions {
  return {
    position: isMobile ? 'bottom-center' : 'top-right',
    hideProgressBar: true,
    closeOnClick: true,
    transition: Slide,
    autoClose: autoclose ? 10000 : false,
  };
}

const ToastContent = (
  {
    icon,
    text,
    button,
    image,
  }: {
    icon?: string, text: string, button?: ReactNode, image?: string,
  },
) => (
  <div className="toast-container">
    <div className="toast-indicator" />
    {
      icon
        ? (
          <div className="icon-container">
            <i className={`fa ${icon} toast-icon`} />
          </div>
        )
        : <img src={image} alt="notification" />
    }
    <div className="toast-content">
      {text}
    </div>
    {
      button && (
        <div className="toast-button-container">
          {button}
        </div>
      )
    }
  </div>
);

ToastContent.defaultProps = {
  button: null,
};

export function toastSuccess(text: string, button?: React.ReactNode): void {
  toast.success(
    <ToastContent image={notificationSucces} text={text} button={button} />, option(!button),
  );
}

export function toastError(text: string, button?: React.ReactNode): void {
  toast.error(
    <ToastContent image={notificationRattachement} text={text} button={button} />, option(!button),
  );
}

export function toastWarning(text: string, button?: React.ReactNode): void {
  toast.warning(
    <ToastContent image={notificationWarning} text={text} button={button} />, option(!button),
  );
}

export function toastInfo(text: string, button?: React.ReactNode): void {
  toast.info(
    <ToastContent image={notificationDelegate} text={text} button={button} />, option(!button),
  );
}

export function notifySuccess<T>(text: string, response?: Promise<T>): Promise<T> {
  toast.success(<ToastContent icon="fa-check-circle" text={text} />, option());
  if (response) {
    return response;
  }
  return null;
}

export function notifyError(error: Promise<WsError>): Promise<WsError> {
  if (Promise.resolve(error) === error) {
    return error.then((errorJson) => {
      toast.error(<ToastContent
        icon="fa-exclamation-circle"
        text={I18n.t(`wsError.${errorJson.errorCode}`, toMessage(errorJson))}
      />, option());
      if (errorJson.errorCode === 'AUTHENTIFICATION_EXPIRED') {
        sessionStorage.clear();
      }
      throw errorJson;
    });
  }
  toast.error(<ToastContent icon="fa-exclamation-circle" text={I18n.t('wsError.INTERNAL_ERROR')} />, option());
  throw error;
}

export function notifyErrorWithMessage(message: string): void {
  toast.error(<ToastContent icon="fa-exclamation-circle" text={message} />, option());
}
